import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getPictureLocaleUrl } from '../../helpers/Utils';
import MultilingualText from 'components/Multilingual/MultilingualText';
import { FormattedDate } from 'react-intl';
import { EventCourse } from 'services/graphqltypes';
import ActivityLabel from 'pages/EventCourse/components/ActivityLabel';
import { useLocation } from 'react-router-dom';
import { parseNominatimLocationName } from 'helpers/utils-typescript';

type CommunityEventCardProp = {
  event: EventCourse;
  communitySlug: string;
  id: number;
  /** true if used in iframe to embed community events in website */
  forEmbeddable?: boolean;
};

/** Render a single event in list of events of a community. Used in embeddable iframe and in "View all" page */
const CommunityEventCard = ({ event, communitySlug, id, forEmbeddable }: CommunityEventCardProp): React.ReactElement => {
  const location = useLocation();

  return (
    <>
      <Link
        target={forEmbeddable ? '_parent' : '_self'} // in iframe '_parent' will open the link in the whole page view, default value is '_self', will open the page inside of iframe
        to={{
          pathname: event.isCourse ? `/course/${event.slug}` : `/event/${event.slug}`,
          state: { from: `${location.pathname}${location.hash}` }
        }}
        key={id}>
        <Card className="d-flex flex-row mb-3">
          <div className="position-relative">
            <img
              loading='lazy'
              alt="Thumbnail"
              src={getPictureLocaleUrl(event.pictureUrl)}
              className="responsive border-0 card-img-left list-img"
            />
            <ActivityLabel event={event} />
          </div>
          <div className="pl-2 d-flex flex-grow-1 min-width-zero">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <p className="list-item-heading mb-1 truncate w-40 w-sm-100">
                <MultilingualText value={event.name} />
              </p>
              <p className="mb-1 text-small w-15 w-sm-100">
                {
                  (event.communityByOrganizerCommunity.slug !== communitySlug) // if the activity is not organized by the community user is viewing, it is an activity organized inside a school class
                    ? <MultilingualText value={event.communityByOrganizerCommunity.name} />  // in that case, instead of location, display the class' name
                    : parseNominatimLocationName(
                      event.locationName,
                      event.locationAddress,
                      event.locationCoordinates, true, false) // otherwise display the location name
                }
              </p>
              <p className="mb-1 text-small w-15 w-sm-100 truncate">
                {<FormattedDate value={event.startTime} year="numeric" month="long" day="numeric" weekday="long" />}
              </p>
            </div>
          </div>
        </Card>
      </Link>
    </>
  );
};

export default CommunityEventCard;
